import { render, staticRenderFns } from "./cardLegend.vue?vue&type=template&id=ffa0d94a"
import script from "./cardLegend.vue?vue&type=script&lang=js"
export * from "./cardLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports